/**
 * @module actions/notes
 */
import axios from 'axios'
import {
  API_URL
  // FILE_STORAGE_API
} from '../constants'

/**
 * @description Creating an note using the API
 * @return {Promise} Axios promise
 */
export function createNote (data) {
  let url = API_URL + '/OrderNote/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Deleting an note using the API
 * @return {Promise} Axios promise
 */
export function deleteNote (id) {
  let url = API_URL + '/OrderNote/Delete'
  return dispatch => {
    return axios.post(url, {
      ItemID: id
    })
  }
}

/**
 * @description Getting order notes
 * @return {Promise} Axios promise
 */
export function getOrderNotes (id) {
  let url = API_URL + '/OrderNote/Get/OrderList/' + id
  return dispatch => {
    return axios.get(url)
  }
}

export function SetRead (data) {
  let url = API_URL + '/OrderNote/SetRead/'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Getting company standard notes
 * @return {Promise} Axios promise
 */
export function getStandardNotes () {
  let url = API_URL + '/Shop/Notes/Get/'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Creating a company standard note
 * @return {Promise} Axios promise
 */
export function createOrDeleteStandardNote (data) {
  let url = API_URL + '/Shop/Notes/Post/'
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/notes.js